import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

export const AlertsMainContainer = styled(Box)` 
position: fixed;
bottom: 20px;
right: calc(50% - 150px);
z-index: 1000;

`;

export const AlertContainer = styled(Box)`
background-color: #2f2f2f;
font-weight: 300;
color: #f0f1f1;
display: flex;
align-items: center;
height: 48px;
border-radius: 4px;
min-width: 300px;
width: fit-content;
justify-content: space-between;
margin-top: 10px;
position: relative;
`;

export const Message = styled(Box)`
margin-left: 20px;
margin-right: 15px;
`;
export const CloseBtn = styled(IconButton)`
color: #f0f1f1 !important;
`;
export const StatusColor = styled(Box)`
height: 100%;
width: 5px;
border-top-left-radius: 4px;
border-bottom-left-radius: 4px;
position: absolute;
left: 0;
height: 48px;
&.alert-success {
background-color: green;
}
&.alert-error {
background-color: red;
}
&.alert-warning {
background-color: orange;
}
&.alert-info {
background-color: #0088d6;
}
`;
